
import { useStateMachine } from "little-state-machine";
import Steps from "../../Components/Steps";
import FormNavigation from "../FormNavigation";
import Axios, { AxiosRequestConfig } from "axios";
import {
  SHOP_NUMBER, STREET_NUMBER,
  STREET_NAME, NEAREST_INTERSECTION,
  SUBURB,
  POSTCODE,
  BUILDING_SHOPPING_CENTRE_NAME,
  BUSINESS_TRADING_NAME,
  NAME,
  NUMBER,
  EMAIL,
  DATE_OF_CHANGE,
  DESCRIPTION
} from "../../Constants";
import { ErrorOrLoading } from "../../../shared";
import { motion } from "framer-motion";
import { useState, useEffect, FormEvent } from "react";
import { useNavigate } from "react-router-dom";

interface Step4bInterface {
  endpoint: string
}

const Step4b = (props: Step4bInterface) => {
  const [loading, setLoading] = useState(false)
  const [postError, setPostError] = useState<Error>()
  const { state } = useStateMachine();
  const navigate = useNavigate()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const submitData = async (e: FormEvent) => {
    e.preventDefault()
    setLoading(true);
    const modifiedData = {
      ...state?.data,
      number: (state?.data?.number_area_code ?? "+61") + (state?.data?.number ?? "")
    }
    const options: AxiosRequestConfig = {
      method: "POST",
      headers: { "content-type": "application/json" },
      data: { data: modifiedData, uploads: {} },
      url: props.endpoint,
    };
    try {
      await Axios(options);
      setLoading(false);
      navigate("/receipt");
    } catch (error) {
      if ((window as any)?.digitalData && (window as any)?.digitalData?.form && (window as any)?.dataLayer) {
        (window as any).digitalData.form.errorList = error;//e.g. How do you currently receive…
        (window as any).digitalData.form.name = "Trade waste from";
        (window as any).dataLayer.push({ event: 'formErrorBlocking' });
      }
      setLoading(false);
      // @ts-ignore
      if (error?.response) {
        // Request made and server responded
        // @ts-ignore
        setPostError(error?.response?.data ? error?.response?.data : "Please try again")
        // @ts-ignore
      } else if (error?.request) {
        // The request was made but no response was received
        setPostError(new Error("network error, please try again"))
      } else {
        // Something happened in setting up the request that triggered an Error
        setPostError(new Error("something went wrong, please try again"))
      }
    }
  }
  const onBack = () => {
    navigate("/step3b");
  };

  return (
    <motion.div
      data-testid="step4b"
      key="step4b"
      initial="initial"
      animate="in"
      exit="out"
      variants={{
        initial: {
          opacity: 0,
        },
        in: {
          opacity: 1,
        },
        out: {
          opacity: 0,
        },
      }}
    >
      <Steps step={4} max={4} />
      <form onSubmit={submitData}>
        {
          (loading || postError) && (
            <div className="relative" style={{ height: "500px", width: "100%" }}>
              <ErrorOrLoading loading={loading} error={postError} />
            </div>
          )
        }
        {!loading && state?.data && !postError && (
          <div>
            <h2>Application preview</h2>
            <p>
              Please review your application, if any details are incorrect please go
              back and correct them prior to submitting your application.
            </p>
            <div className="wc-msg wc-msg--grey wc-concession-form">
              <section>
                <h3>Application type</h3>
                <p>{state?.data?.trade_waste_change ?? ""}</p>
              </section>
              <hr />
              <section>
                <h3>Business details</h3>
                <h4>Site details</h4>
                <dl>
                  <dt>Unit/shop number</dt>
                  <dd>{state?.data[SHOP_NUMBER] ? state?.data[SHOP_NUMBER] : ""}</dd>
                  <dt>Street number</dt>
                  <dd>{state?.data[STREET_NUMBER] ? state?.data[STREET_NUMBER] : ""}</dd>
                  <dt>Street name</dt>
                  <dd>{state?.data[STREET_NAME] ? state?.data[STREET_NAME] : ""}</dd>
                  <dt>Nearest intersection</dt>
                  <dd>{state?.data[NEAREST_INTERSECTION] ? state?.data[NEAREST_INTERSECTION] : ""}</dd>
                  <dt>Suburb</dt>
                  <dd>{state?.data[SUBURB] ? state?.data[SUBURB] : ""}</dd>
                  <dt>Postcode</dt>
                  <dd>{state?.data[POSTCODE] ? state?.data[POSTCODE] : ""}</dd>
                  <dt>Building / Shopping centre name</dt>
                  <dd>{state?.data[BUILDING_SHOPPING_CENTRE_NAME] ? state?.data[BUILDING_SHOPPING_CENTRE_NAME] : ""}</dd>
                </dl>
              </section>
              <hr />
              <section>
                <h4>Your Details</h4>
                <dl>
                  <dt>Name</dt>
                  <dd>{state?.data[NAME] ?? ""}</dd>
                  <dt>Phone number</dt>
                  <dd>{state?.data.number_area_code ?? "+61"}{state?.data[NUMBER] ?? ""}</dd>
                  <dt>Email Address</dt>
                  <dd>{state?.data[EMAIL] ?? ""}</dd>
                  <dt>Business trading name</dt>
                  <dd>{state?.data[BUSINESS_TRADING_NAME] ?? ""}</dd>
                </dl>
              </section>
              <hr />
              <section>
                <h3>Process Details</h3>
                <h4>Change Details</h4>
                <dl>
                  <dt>Date of change</dt>
                  <dd>{state?.data[DATE_OF_CHANGE] ? new Date(state?.data[DATE_OF_CHANGE]).toString() : ""}</dd>
                  <dt>Description of change</dt>
                  <dd>{state?.data[DESCRIPTION] ?? ""}</dd>
                </dl>
              </section>
            </div>
          </div>
        )
        }
        <FormNavigation isLast={true} handleBack={onBack} isDisabled={loading} />
      </form >
    </motion.div>
  );
};

export default Step4b;
